(function(){
  'use strict';

  // Default to solid header on pages without a dark hero (i.e. PDP, account, etc.)
  if (!document.getElementById('hero')) document.body.classList.add('header-solid');

  // Rotating util-bar messages
  (function(){
    var msgs = document.querySelectorAll('#rotating-msgs .rot-msg');
    if (!msgs.length) return;
    var idx = 0;
    setInterval(function(){ msgs[idx].classList.remove('active'); idx = (idx + 1) % msgs.length; msgs[idx].classList.add('active'); }, 4000);
  })();

  // Auto-tag PDP section headings with data-reveal so every block animates
  // the same way the homepage and rewards page do — without touching 23 sections by hand.
  document.querySelectorAll(
    '.site > section .head, ' +
    '.site > section > h2, ' +
    '.site > section > h3, ' +
    '.site > section > .ey, ' +
    '.site > section > .eyebrow, ' +
    '.s-10 .text, .s-11 .stats, .s-12 .grid, .s-13 .steps, ' +
    '.s-14 .routine, .s-15 .bundle, .s-17 .grid, .s-19 .acc, ' +
    '.s-21 .logos, .s-22 .text'
  ).forEach(function(el){
    if (!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal', '');
  });

  // Scroll-reveal — same observer config as homepage
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function(el){ io.observe(el); });
  } else {
    revealEls.forEach(function(el){ el.classList.add('is-in'); });
  }

  // Gallery thumbnail click → slide-in-from-right swap
  (function(){
    var rail = document.getElementById('gallery-rail');
    var main = document.getElementById('gallery-main');
    if (!rail || !main) return;
    rail.addEventListener('click', function(e){
      var thumb = e.target.closest('.thumb');
      if (!thumb || thumb.classList.contains('video')) return;
      var src = thumb.dataset.img;
      if (!src || src === main.src) return;
      rail.querySelectorAll('.thumb').forEach(function(t){ t.classList.remove('on'); });
      thumb.classList.add('on');
      // Remove animation class, swap src, force reflow, re-add to retrigger
      main.classList.remove('is-swapping');
      void main.offsetWidth;
      main.src = src;
      main.classList.add('is-swapping');
    });
  })();

  // ---------- Metafield preview toggle (design QA only) ----------
  // In production these toggles are replaced by Liquid conditionals reading
  // `product.metafields.custom.show_routines` and
  // `product.metafields.custom.show_better_together`.
  document.querySelectorAll('.meta-preview [data-meta-toggle]').forEach(function(input){
    input.addEventListener('change', function(){
      var key = input.dataset.metaToggle;
      if (key === 'show_routines') {
        document.body.classList.toggle('hide-routines', !input.checked);
      } else if (key === 'show_better_together') {
        document.body.classList.toggle('hide-better-together', !input.checked);
      }
    });
  });

  // Sticky add-to-cart bar — triggers when the hero scrolls out of view
  var heroBlock = document.getElementById('hero-block');
  var stickyBar = document.getElementById('sec-23');
  if (heroBlock && stickyBar && 'IntersectionObserver' in window) {
    var heroObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.intersectionRatio < 0.2) stickyBar.classList.add('show');
        else stickyBar.classList.remove('show');
      });
    }, { threshold: [0, 0.2, 0.5, 1] });
    heroObserver.observe(heroBlock);
  }

  // -----------------------------------------------------------------
  // SHOPIFY SUBSCRIPTIONS — Subscribe & Save / One-time picker
  // -----------------------------------------------------------------
  // Clicking either card toggles `.on`. Selecting SUBSCRIBE fills the
  // hidden `selling_plan` input with the active frequency's plan ID
  // and recomputes the displayed price, +pts line, and Klarna split
  // from the discount %. ONE-TIME clears the plan and shows base price.
  //
  // Production note: replace the hard-coded data-discount values with
  // {{ plan.price_adjustments[0].value }} when rendering from Liquid.
  // -----------------------------------------------------------------
  (function(){
    var form     = document.getElementById('bb-form');
    if (!form) return;
    var basePrice = parseFloat(form.dataset.basePrice || '25.00');
    var compareAt = parseFloat(form.dataset.compareAtPrice || form.dataset.basePrice || '0');
    var currency  = form.dataset.currency || '€';
    var hiddenPlan = document.getElementById('current-plan');
    var freqSelect = document.getElementById('bb-freq');
    var cards    = form.querySelectorAll('.bb-commit .card');
    var pointsEl = form.querySelector('.js-points');
    var klarnaEl = form.querySelector('.js-klarna');
    var subPriceEls = form.querySelectorAll('.js-sub-price');
    // .js-current-price can live outside the form (e.g. the sticky ATC bar)
    var currentPriceEls = document.querySelectorAll('.js-current-price');
    var wasPriceEls = document.querySelectorAll('.js-was-price');
    var subDiscountEl = form.querySelector('.js-discount');
    var subCard  = form.querySelector('.card[data-mode="subscribe"]');

    function fmt(n){ return currency + n.toFixed(2); }

    function refresh(){
      var activeCard = form.querySelector('.bb-commit .card.on');
      /* Default to 'onetime' if no subscribe card exists (product has no selling plan).
         Otherwise default to 'subscribe' when a sub card exists but isn't yet .on. */
      var mode = activeCard ? activeCard.dataset.mode : (subCard ? 'subscribe' : 'onetime');
      var discount = 0;
      var effectivePrice = basePrice;
      var planId = '';

      if (mode === 'subscribe') {
        // Read the active frequency option for its discount + plan ID
        var opt = freqSelect && freqSelect.options[freqSelect.selectedIndex];
        discount = opt ? parseFloat(opt.dataset.discount || subCard.dataset.discount || '15') : 15;
        planId   = opt ? opt.value : '';
        effectivePrice = basePrice * (1 - discount / 100);
        subPriceEls.forEach(function(el){ el.textContent = fmt(effectivePrice); });
        if (subDiscountEl) subDiscountEl.textContent = String(Math.round(discount));
      }

      // ATC button always shows the price the customer will actually pay
      // — sub-discounted if subscribe is active, base if one-time.
      currentPriceEls.forEach(function(el){ el.textContent = fmt(effectivePrice); });

      // Compared (struck) price — use the higher of:
      //   • variant.compare_at_price (real RRP or fake compare from Shop metafield), or
      //   • basePrice (so subscribe-mode strikes the one-time price as the "was").
      // Hide when it's not actually higher than the effective price.
      var wasValue = Math.max(compareAt || 0, mode === 'subscribe' ? basePrice : 0);
      wasPriceEls.forEach(function(el){
        if (wasValue > effectivePrice + 0.001) {
          el.textContent = fmt(wasValue);
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });

      // Hidden input — empty for one-time, plan ID for subscribe
      if (hiddenPlan) hiddenPlan.value = planId;

      // Re-compute points (5 pts per €1 spent, rounded down)
      if (pointsEl) pointsEl.textContent = String(Math.floor(effectivePrice * 5));
      // Klarna — three equal instalments
      if (klarnaEl) klarnaEl.textContent = fmt(effectivePrice / 3);
    }

    // Card click → toggle active state
    cards.forEach(function(card){
      card.addEventListener('click', function(e){
        // Don't intercept clicks on the inner frequency <select> or its options
        if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION' || e.target.tagName === 'A') return;
        cards.forEach(function(c){ c.classList.remove('on'); });
        card.classList.add('on');
        refresh();
      });
    });

    // Frequency change → recompute (only relevant when subscribe is active)
    if (freqSelect) freqSelect.addEventListener('change', refresh);

    // Initial paint
    refresh();
  })();

  // -----------------------------------------------------------------
  // OKENDO REVIEW CTA → opens Okendo's "Write a review" form.
  // The actual Okendo → Rivo points award happens server-side: Rivo
  // has a native Okendo integration that listens to review-submitted
  // webhooks. All we do here on the frontend is open the form and
  // give the customer a confirmation when the form is submitted.
  // -----------------------------------------------------------------
  var reviewCta = document.getElementById('rivo-review-cta');
  var reviewEarn = document.getElementById('rivo-review-earn');

  function openOkendoReviewForm(e){
    if (e) e.preventDefault();
    // Try Okendo's official APIs first, in order of preference.
    try {
      if (window.okendoReviewsWidget && window.okendoReviewsWidget.openWriteReview) {
        window.okendoReviewsWidget.openWriteReview();
        return;
      }
      if (window.OkendoWidgetClient && window.OkendoWidgetClient.openWriteReview) {
        window.OkendoWidgetClient.openWriteReview();
        return;
      }
      // Fallback — find the Okendo "write review" button rendered by their widget and click it.
      var okeBtn = document.querySelector(
        '[data-oke-reviews-widget-write-review-btn], ' +
        '[data-oke-reviews-modal-write-review-button], ' +
        '.oke-reviews-writeReview-button, ' +
        'button[data-oke-write-review]:not(#rivo-review-cta)'
      );
      if (okeBtn) { okeBtn.click(); return; }
    } catch (err) { /* swallow — fall through to scroll */ }
    // Last resort — scroll to the reviews grid so the user can find Okendo's own CTA.
    var revs = document.querySelector('.reviews-grid');
    if (revs) revs.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (reviewCta) reviewCta.addEventListener('click', openOkendoReviewForm);
  // Any element marked data-open-okendo on the page can also trigger the form
  // (e.g. the "Write a review" link beside the buy-box stars).
  document.querySelectorAll('[data-open-okendo]').forEach(function(el){
    if (el !== reviewCta) el.addEventListener('click', openOkendoReviewForm);
  });

  // Auto-open Okendo when arriving with ?openReview=1 (e.g. from the rewards
  // page card or the post-purchase order-status page).
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('openReview') === '1') {
      // Wait briefly for Okendo's widget to mount, then open the form.
      var tries = 0, max = 20;
      var timer = setInterval(function(){
        tries++;
        var okeReady =
          (window.okendoReviewsWidget && window.okendoReviewsWidget.openWriteReview) ||
          (window.OkendoWidgetClient && window.OkendoWidgetClient.openWriteReview) ||
          document.querySelector('[data-oke-reviews-widget-write-review-btn], .oke-reviews-writeReview-button');
        if (okeReady || tries >= max) {
          clearInterval(timer);
          openOkendoReviewForm();
        }
      }, 350);
    }
  } catch(e){ /* swallow */ }

  // Mark the callout as "submitted" once Okendo confirms a review has been left.
  // Okendo fires a few different event names depending on widget version — handle them all.
  function markReviewSubmitted(){
    if (!reviewEarn) return;
    reviewEarn.classList.add('is-done');
    var lbl  = reviewEarn.querySelector('.copy .lbl');
    var body = reviewEarn.querySelector('.copy');
    var cta  = reviewEarn.querySelector('.cta');
    if (lbl)  lbl.textContent = '✓ Review submitted';
    if (body) body.innerHTML =
      '<span class="lbl">✓ Review submitted</span>' +
      'Thanks for sharing your skin story. Your <strong>250–500 points</strong> will appear in your account once your review is verified.';
    if (cta) cta.style.display = 'none';
  }

  ['okendo-review-submitted', 'okeReviewSubmitted', 'oke:reviews:submitted'].forEach(function (name) {
    window.addEventListener(name, markReviewSubmitted);
    document.addEventListener(name, markReviewSubmitted);
  });
  // postMessage fallback (some Okendo widgets post to parent when the modal submits)
  window.addEventListener('message', function (e) {
    var d = e && e.data;
    if (!d) return;
    var hit =
      (typeof d === 'string' && /okendo[:\-_]review[:\-_]submitted|okeReviewSubmitted/i.test(d)) ||
      (typeof d === 'object' && (
        d.type === 'okendo-review-submitted' ||
        d.event === 'okeReviewSubmitted' ||
        (d.namespace === 'okendo' && d.action === 'review-submitted')
      ));
    if (hit) markReviewSubmitted();
  });
})();


/* ============================================================
   HOW-TO-USE — small interactions for the v2 layout:
     • AM/PM toggle in the section header (visual state only;
       you can hook it to swap step copy if AM and PM differ)
     • Glow-picker tile selection (single-select; .on class)
   ============================================================ */
(function(){
  // AM / PM toggle — flips the section's data-mode, which the CSS uses to
  // show the matching <ol class="ritual-steps am|pm">. The toggle itself
  // is hidden by CSS when data-has is "am-only" or "pm-only".
  document.querySelectorAll('.s-13').forEach(function(section){
    var wrap = section.querySelector('.ampm-toggle');
    if (!wrap) return;
    var btns = wrap.querySelectorAll('button');
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        var mode = b.dataset.mode || b.textContent.trim().toLowerCase();
        btns.forEach(function(x){ x.classList.remove('on'); });
        b.classList.add('on');
        section.setAttribute('data-mode', mode);
        document.dispatchEvent(new CustomEvent('pm:howto:mode', { detail: { mode: mode } }));
      });
    });
  });

  // Glow-tile picker — single selection, hover/click to highlight
  document.querySelectorAll('.s-13 .glow-tiles').forEach(function(grid){
    var tiles = grid.querySelectorAll('.g-tile');
    tiles.forEach(function(t){
      t.addEventListener('click', function(e){
        e.preventDefault();
        tiles.forEach(function(x){ x.classList.remove('on'); });
        t.classList.add('on');
        document.dispatchEvent(new CustomEvent('pm:howto:glow', { detail: { level: t.dataset.glowLevel } }));
      });
    });
  });
})();

/* ============================================================
   BUNDLE / ROUTINE TOTAL — recalculates the displayed total from
   each tile's data-price attribute. In production, the Liquid
   template already prints the correct sum, so this is a no-op
   unless data-price values are present. For the static mockup
   it keeps the price honest if a designer swaps a tile.
   ============================================================ */
(function(){
  function recalc(sectionSel, totalSel){
    var section = document.querySelector(sectionSel);
    if (!section) return;
    var totalEl = section.querySelector(totalSel);
    if (!totalEl) return;
    /* Only run if a dedicated "now" element exists (so we don't blow
       away the <span class="was"> strikethrough). When the new
       structured markup isn't present, leave the Liquid output alone —
       it's already rendered with the shop's currency. */
    var nowEl = totalEl.querySelector('[data-bundle-total-now], .now');
    if (!nowEl) return;
    var tiles = section.querySelectorAll('[data-bundle-tile]');
    if (!tiles.length) return;
    var sum = 0, any = false;
    tiles.forEach(function(t){
      var v = parseFloat(t.dataset.price || '');
      if (!isNaN(v)) { sum += v; any = true; }
    });
    if (!any) return;
    /* Reuse the existing currency symbol from the rendered text so we
       don't hardcode €. Falls back to whatever Shopify rendered. */
    var existing = nowEl.textContent.trim();
    var sym = existing.match(/^[^0-9\-+.,]*/);
    var prefix = (sym && sym[0]) || '';
    nowEl.textContent = prefix + sum.toFixed(2);
  }
  recalc('#sec-15', '[data-bundle-total]');
})();

/* ============================================================
   BULK ADD-TO-CART — wired to both:
     [data-add-routine]  (custom.routine_product)
     [data-add-bundle]   (custom.bundles_product)

   On click:
     1.  Build the line-item array from data-variant-ids
         (Liquid hands them in via `data-variant-ids="123,456,…"`).
     2.  POST to /cart/add.js once with all items in `items[]` —
         Shopify's bulk-add endpoint handles the full set in
         a single round-trip.
     3.  On success, dispatch `pm:cart-drawer:open` for the theme
         to listen to. Most themes (Dawn, Impulse, Pestle's v4)
         open the drawer from this event. As a fallback we also
         call window.PMCart.open() if a global cart controller
         is exposed.
     4.  Show a small bottom-right toast confirming the add. The
         toast is mockup-only — in production the cart drawer
         itself is the confirmation surface.

   In the local mockup (no /cart/add.js endpoint), the fetch
   throws — we catch it and still show the toast so the
   interaction is visible in the static preview.
   ============================================================ */
(function(){
  var buttons = document.querySelectorAll('[data-add-routine], [data-add-bundle]');
  if (!buttons.length) return;

  function toast(msg){
    var t = document.querySelector('.pm-toast');
    if (!t) { t = document.createElement('div'); t.className = 'pm-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    requestAnimationFrame(function(){ t.classList.add('show'); });
    clearTimeout(t._h);
    t._h = setTimeout(function(){ t.classList.remove('show'); }, 2400);
  }

  function openCartDrawer(){
    document.dispatchEvent(new CustomEvent('pm:cart-drawer:open'));
    if (window.PMCart && typeof window.PMCart.open === 'function') window.PMCart.open();
  }

  buttons.forEach(function(btn){
    var noun = btn.hasAttribute('data-add-bundle') ? 'Bundle' : 'Routine';

    btn.addEventListener('click', function(e){
      e.preventDefault();
      // Accept either data-variant-ids (plural, legacy) or data-variant-id (singular, new bundle-as-cart-product pattern)
      var idsAttr = btn.dataset.variantIds || btn.dataset.variantId || '';
      var ids = idsAttr.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
      if (!ids.length) { toast(noun + ' is empty'); return; }

      btn.disabled = true;
      var original = btn.innerHTML;
      btn.innerHTML = 'Adding…';

      var items = ids.map(function(id){ return { id: id, quantity: 1 }; });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res){ return res.ok ? res.json() : Promise.reject(res); })
      .then(function(){
        btn.classList.add('is-added');
        toast(noun + ' added — ' + ids.length + ' items in your bag');
        openCartDrawer();
      })
      .catch(function(){
        // Mockup / dev fallback — endpoint unavailable in static preview
        btn.classList.add('is-added');
        toast(noun + ' added — ' + ids.length + ' items in your bag');
        openCartDrawer();
      })
      .then(function(){
        btn.disabled = false;
        btn.innerHTML = original;
      });
    });
  });
})();

/* Cart drawer bridge — listens for pm:cart-drawer:open and opens the existing P&M drawer. */
(function(){
  document.addEventListener('pm:cart-drawer:open', function(){
    try { if (typeof cart !== 'undefined' && typeof cart.refresh === 'function') cart.refresh(); } catch(e){}
    var d = document.getElementById('cart-drawer');
    if (d) d.classList.add('active');
  });
})();


/* ============================================================
   HEADER CART BUTTON — wires #cart-button click to open the
   cart drawer. Normally provided by product.min.js / scripts.min.js
   which the pdp-v2 template doesn't load. Drawer contents are
   server-rendered into snippets/cart-drawer.liquid at page load.
   ============================================================ */
(function(){
  var btn = document.getElementById('cart-button');
  if (!btn) return;
  btn.addEventListener('click', function(e){
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('pm:cart-drawer:open'));
  });
})();

/* ============================================================
   BUY-BOX ATC — intercept #bb-form submission so it POSTs to
   /cart/add.js (AJAX, no /cart redirect), then opens the cart
   drawer via the pm:cart-drawer:open bridge.
   ============================================================ */
(function(){
  var form = document.getElementById('bb-form');
  if (!form) return;

  form.addEventListener('submit', function(e){
    e.preventDefault();

    /* .bb-atc = B2C add button; .atc-row .btn = B2B cases buy button. Both may carry data-auto-add-id (GWP). */
    var btn = form.querySelector('.bb-atc') || form.querySelector('.atc-row .btn');
    if (btn && btn.disabled) return;
    var originalHTML = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = '<span class="bb-atc-label">Adding…</span>'; }

    /* ---- BELT-AND-BRACES: re-read picker state right before submit ----
       Guarantees the hidden #current-plan input reflects whatever card is
       currently active. Without this, a race condition where the picker's
       initial refresh() hasn't run yet (or a stale value from a previous
       toggle) could leave the input empty and the item adds as one-time. */
    var hiddenPlanEl = document.getElementById('current-plan');
    var subCardEl = form.querySelector('.bb-commit .card.on[data-mode="subscribe"]');
    var freqSelEl = document.getElementById('bb-freq');
    if (hiddenPlanEl) {
      if (subCardEl && freqSelEl && freqSelEl.value) {
        hiddenPlanEl.value = freqSelEl.value;
      } else {
        hiddenPlanEl.value = '';
      }
    }
    console.log('[pdp-v2 ATC] subscribe card active?', !!subCardEl,
                '— selling_plan hidden value:', hiddenPlanEl ? hiddenPlanEl.value : 'NO INPUT');

    var fd = new FormData(form);
    console.log('[pdp-v2 ATC] FormData selling_plan:', fd.get('selling_plan'),
                '— variant id:', fd.get('id'), '— qty:', fd.get('quantity'));
    /* Strip empty selling_plan so Shopify treats it as one-time */
    if (fd.get('selling_plan') === '') fd.delete('selling_plan');

    /* Use the items[] JSON path whenever:
         a) GWP auto-add is in play (button has data-auto-add-id), OR
         b) a selling_plan is set (subscribe & save).
       The JSON path is the documented Shopify Ajax cart format for
       multi-item / selling-plan adds and is more reliable than
       FormData when selling_plan is involved — some app proxies and
       middleware strip unknown form fields but pass the JSON body
       through untouched. */
    var autoAddId = btn ? btn.dataset.autoAddId : null;
    var sellingPlan = fd.get('selling_plan');
    var useJsonPath = !!autoAddId || (sellingPlan && sellingPlan !== '');
    var fetchOpts;
    if (useJsonPath) {
      var mainId = parseInt(fd.get('id'), 10);
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      var mainItem = { id: mainId, quantity: qty };
      if (sellingPlan) mainItem.selling_plan = parseInt(sellingPlan, 10);
      /* Carry the form's line-item properties onto the main item — the JSON path
         doesn't include the form fields, so without this the B2B cases props
         (_quantity_multiple, Pack size) would be lost and the line wouldn't show as cases. */
      var props = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (inp) {
        var m = inp.name.match(/^properties\[(.+)\]$/);
        if (m && inp.value !== '') props[m[1]] = inp.value;
      });
      if (Object.keys(props).length) mainItem.properties = props;
      var items = [mainItem];
      if (autoAddId) {
        var gwpId = parseInt(autoAddId, 10);
        /* Free gift: every X units bought = Y gifts (data-auto-add-every / -qty; default 1-for-1),
           linked to its parent via _gwp_parent_id so the cart pairs them. The property keeps
           it on its own line, so the gift can be the same product. The free-gift section's
           cart sync corrects the total if the cart already held units of this product. */
        var gwpEvery = parseInt(btn.dataset.autoAddEvery, 10) || 1;
        var gwpPer = parseInt(btn.dataset.autoAddQty, 10) || 1;
        var gwpQty = Math.floor(qty / gwpEvery) * gwpPer;
        if (gwpId && gwpQty > 0) items.push({ id: gwpId, quantity: gwpQty, properties: { _gwp_parent_id: String(mainId) } });
      }
      console.log('[pdp-v2 ATC] using JSON items[] path:', items);
      fetchOpts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      };
    } else {
      console.log('[pdp-v2 ATC] using FormData path (one-time)');
      fetchOpts = {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      };
    }

    fetch('/cart/add.js', fetchOpts)
    .then(function(res){
      if (!res.ok) return res.json().then(function(err){ return Promise.reject(err); });
      return res.json();
    })
    .then(function(){
      /* Refresh drawer contents if the theme's cart object is available */
      if (typeof cart !== 'undefined' && typeof cart.refresh === 'function') {
        try { cart.refresh(); } catch(e){}
      }
      document.dispatchEvent(new CustomEvent('pm:cart-drawer:open'));
    })
    .catch(function(err){
      var msg = (err && err.description) || (err && err.message) || 'Add to cart failed';
      try { window.alert(msg); } catch(e){}
    })
    .then(function(){
      if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
    });
  });
})();

/* ============================================================
   FULL TRANSPARENCY accordions (.s-20) — click a row to toggle
   its .open state, revealing the .acc-body beneath it.
   ============================================================ */
(function(){
  var section = document.getElementById('sec-20');
  if (!section) return;
  section.addEventListener('click', function(e){
    var row = e.target.closest('.acc-row');
    if (!row) return;
    var item = row.parentElement;
    if (!item || !item.classList.contains('acc')) return;
    item.classList.toggle('open');
  });
})();

/* ============================================================
   FAQ accordions (.s-19) — click a row to toggle .open and
   reveal the answer beneath the question.
   ============================================================ */
(function(){
  var section = document.getElementById('sec-19');
  if (!section) return;
  section.addEventListener('click', function(e){
    var item = e.target.closest('.faq');
    if (!item || !section.contains(item)) return;
    item.classList.toggle('open');
  });
})();


/* ============================================================
   Before / After slider + week-tab toggle (.s-ba)
   ============================================================ */
(function(){
  var section = document.getElementById('sec-ba');
  if (!section) return;
  var wrap = section.querySelector('#ba-wrap') || section.querySelector('.ba-wrap');
  var handle = section.querySelector('#ba-handle') || section.querySelector('.ba-handle');
  var after = section.querySelector('#ba-after') || section.querySelector('.ba-img.after');
  var afterTag = section.querySelector('#ba-after-tag');
  var wkLabel = section.querySelector('#ba-wk-label');
  var wkScale = section.querySelector('#ba-wk-scale');
  var weekBtns = section.querySelectorAll('.ba-weeks button');
  if (!wrap || !handle || !after) return;

  var dragging = false;
  function setPos(x){
    var rect = wrap.getBoundingClientRect();
    var pct = Math.max(2, Math.min(98, ((x - rect.left) / rect.width) * 100));
    handle.style.left = pct + '%';
    after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
  }
  handle.addEventListener('pointerdown', function(e){ dragging = true; e.preventDefault(); });
  window.addEventListener('pointerup', function(){ dragging = false; });
  window.addEventListener('pointermove', function(e){ if (dragging) setPos(e.clientX); });
  wrap.addEventListener('pointerdown', function(e){ if (e.target !== handle) setPos(e.clientX); });

  function setWeek(wk){
    after.setAttribute('data-wk', wk);
    if (wkLabel)  wkLabel.textContent  = 'Week ' + wk;
    if (afterTag) afterTag.textContent = 'After · Week ' + wk;
    if (wkScale)  wkScale.textContent  = 'Week ' + wk;
    var img = '';
    weekBtns.forEach(function(b){
      var on = b.dataset.wk === String(wk);
      b.classList.toggle('on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) img = b.dataset.image || '';
    });
    if (img) {
      after.style.backgroundImage = "url('" + img + "')";
      after.style.backgroundSize = 'cover';
      after.style.backgroundPosition = 'center';
    }
    handle.style.left = '50%';
    after.style.clipPath = 'inset(0 0 0 50%)';
  }
  weekBtns.forEach(function(b){
    b.addEventListener('click', function(){ setWeek(b.dataset.wk); });
  });
})();

/* ============================================================
   Press Quote Rotator (.s-pressrot)
   ============================================================ */
(function(){
  var section = document.getElementById('sec-pressrot');
  if (!section) return;
  var slides = section.querySelectorAll('.quote-slide');
  var dots   = section.querySelectorAll('.dots button');
  if (slides.length < 2) return;
  var i = 0;
  function paint(){
    slides.forEach(function(s, idx){ s.classList.toggle('active', idx === i); });
    dots.forEach(function(d, idx){ d.classList.toggle('on', idx === i); });
  }
  dots.forEach(function(d){
    d.addEventListener('click', function(){ i = parseInt(d.dataset.i, 10) || 0; paint(); });
  });
  setInterval(function(){ i = (i + 1) % slides.length; paint(); }, 6000);
})();
